import React, { useState } from "react";
import styled from "styled-components";
// import { MdArrowBack, MdArrowForward } from "react-icons/md";

const ClientTestimonials = () => {
  const [currentVideo] = useState(0);
  const videos = [
    "https://www.youtube.com/embed/Tf-ba5RPaoc?si=Ag3PlnRJJ6ZcsVr5&modestbranding=1&rel=0",
  ];

  return (
    <ClientTestimonialsStyles className="home_parent_wrapper">
      <h2 className="heading">Hear from our clients</h2>
      <iframe
        className="video"
        width="100%"
        height="479"
        src={videos[currentVideo]}
        title="Testimonial video"
      ></iframe>
      {/* <div className="pagination">
        <div
          className={`action-btn ${currentVideo === 0 && "disabled"}`}
          onClick={() =>
            setCurrentVideo((prev) => (currentVideo !== 0 ? prev - 1 : null))
          }
        >
          <MdArrowBack />
          <button>Previous</button>
        </div>
        <div
          className={`action-btn ${currentVideo === 2 && "disabled"}`}
          onClick={() =>
            setCurrentVideo((prev) => (currentVideo !== 2 ? prev + 1 : null))
          }
        >
          <button>Next</button>
          <MdArrowForward />
        </div>
      </div> */}
    </ClientTestimonialsStyles>
  );
};

export default ClientTestimonials;

const ClientTestimonialsStyles = styled.section`
  padding: 8rem 0;
  text-align: center;

  .heading {
    font-weight: 700;
    font-size: 5.8rem;
    margin-bottom: 5.6rem;
  }

  .video {
    border-radius: 24px;
  }

  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  .action-btn {
    border: 1px solid #d0d5dd;
    display: flex;
    gap: 1.217rem;
    align-items: center;
    font-weight: 500;
    padding: 0.8rem 1.4rem;
    border-radius: 0.8rem;
    cursor: pointer;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    transition: all 0.15s ease-in-out;
  }

  .action-btn:hover {
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.5);
    font-weight: 600;
  }

  .action-btn:active {
    opacity: 0.5;
    user-select: none;
  }

  .disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  }

  .disabled:hover {
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    font-weight: 500;
    cursor: not-allowed;
  }

  .pagination {
    display: flex;
    justify-content: center;
    gap: 1.6rem;
    margin-top: 2.4rem;
  }

  @media screen and (max-width: 900px) {
    .heading {
      font-weight: 700;
      font-size: 2.4rem;
      margin-bottom: 2.4rem;
    }
  }
`;
